export function Pending() {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="8" cy="8" r="8" fill="#FEC60A" />
			<path
				d="M6.85718 3.42859V9.14287L10.2857 11.4286"
				stroke="white"
				strokeWidth="1.3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
